<template>
    <div>
        <section class="page-title-area d-flex align-items-center bg_cover"
                 style="background-image: url('/images/page-title-bg.jpg')">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="page-title-item text-center">
                            <h3 class="title">Login</h3>
                            <nav aria-label="breadcrumb">
                                <ol class="breadcrumb">
                                    <li class="breadcrumb-item">
                                        <router-link to="/">Home</router-link>
                                    </li>
                                    <li class="breadcrumb-item active" aria-current="page">Forgot Password</li>
                                </ol>
                            </nav>
                        </div> <!-- page title item -->
                    </div>
                </div> <!-- row -->
            </div> <!-- row -->
            <div class="page-title-shape">
                <img src="/images/banner-shape.png" alt="shape">
            </div> <!-- page title shape -->
        </section>
        <section class="contact-touch-area pt-85 pb-90">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-lg-9">
                        <div class="contact-touch-part">
                            <div class="row">
                                <div class="col-lg-12">
                                    <div class="secton-title text-center">
                                        <h5 class="title">Forgot Password</h5>
                                    </div>
                                </div>
                            </div>
                            <form action="">
                                        <div class="alert squares alert-danger" v-if="invalid">
                                            <p style="color: red;">Invalid email</p>
                                        </div>
                                <div class="row">
                                    <div class="col-lg-8">
                                        <div class="input-box mt-35">
                                            <label>Enter Email for reset.</label>
                                            <input v-model="form.email" type="email" placeholder="Enter Email" class="form-control">
                                            <small style="color: red" v-if="error && errors.email">{{ errors.email[0] }}</small>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-12">
                                    <div class="input-box mt-35 text-center">
                                        <button @click.prevent="reset()">Reset</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <div class="vld-parent">
            <loading name="loader" :active.sync="isLoading"
                     :can-cancel="false"
                     :is-full-page="fullPage">
            </loading>
        </div>
    </div>
</template>

<script>
    // Import component
    import Loading from 'vue-loading-overlay';
    // Import stylesheet
    import 'vue-loading-overlay/dist/vue-loading.css';

    export default {
        name: "ForgotPassword",
        components: {
            Loading
        },
        data(){
            return{
                error: false,
                errors: {},
                invalid: false,
                isLoading: false,
                fullPage: true,
                form: {
                    email: '',
                }
            }
        },
        methods:{

            reset() {

                this.error = false;
                this.invalid = false;

                if(this.form.email == ""){
                    this.error = true;
                    this.errors.email = ['You have to input an email'];
                }else{
                    this.isLoading = true;
                    this.axios.post('/auth/emailCheck',{
                        email: this.form.email
                    })
                        .then(() =>{
                            this.axios.post('/password/email',{
                                email:this.form.email
                            })
                                .then(() =>{
                                    this.isLoading = false;
                                    this.$swal.fire({
                                        icon: 'success',
                                        title: 'Success',
                                        text: 'Reset email sent'
                                    })
                                        .then(()=>{
                                            this.$router.push('/');
                                        })
                                })
                                .catch(()=>{
                                    this.isLoading = false;
                                    this.$swal.fire({
                                        icon: 'error',
                                        title: 'Error',
                                        text: 'Something went wrong, try again'
                                    });
                                })
                        })
                        .catch(error =>{
                            if (error.response.data.errors) {
                                this.error = true;
                                this.errors = error.response.data.errors;
                            }else{
                                this.invalid = true;
                            }

                            this.isLoading = false
                        })
                }



            }
        }

    }
</script>

<style scoped>

</style>